<template>
  <el-dialog
    v-if="DialogVisible"
    title="上传网价"
    :visible.sync="DialogVisible"
    width="600px"
    class="large-padding-dialog"
    :close-on-click-modal="false"
    :before-close="Hide"
  >
    <!--当用户通过点击关闭图标或遮罩关闭 Dialog 时触发 before-close 对应方法-->
    <el-form
      :model="DialogFormData"
      ref="DialogFormData"
      :rules="dialogRules"
      label-position="left"
      label-width="0"
    >
      <div style="margin-bottom: 15px">1. 选择日期</div>
      <el-form-item prop="info_time">
        <el-date-picker
          v-model="DialogFormData.info_time"
          type="date"
          :placeholder="l('选择日期')"
          value-format="yyyy-MM-dd"
          :clearable="false"
          :disabled="Type == 'Edit'"
        >
        </el-date-picker>
      </el-form-item>
      <div style="margin-bottom: 15px">
        2. 下载EXCEL模板，并填写网价信息
        <span
          class="ViewLink"
          style="margin-left: 10px"
          @click="downloadTemplate"
          >点击此处下载模板</span
        >
      </div>
      <div style="margin-bottom: 15px">
        3. 上传填写完毕的EXCEL文件，点击提交
      </div>

      <ResourceUpLoad
        style="display: inline-block"
        prop="file_url"
        usage="website_config"
        file_type="document"
        :initResourceUrl.sync="DialogFormData.file_url"
        :disabled="Type == 'View'"
      />
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="Hide">{{l("取 消")}}</el-button>
      <el-button type="primary" @click="submitForm">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";

export default {
  name: "CreateOrEditMarketPrice",
  mixins: [dialogMixin],
  data() {
    return {
      DialogFormData: {
        info_time: this.$utils.formatDate(new Date().getTime()),
        file_url: "",
      },
      dialogRules: {
        info_time: [{ required: true, message: "请选择时间", trigger: "blur" }],
        file_url: [{ required: true, message: "请上传文件", trigger: "blur" }],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs["DialogFormData"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }

        this.axios
          .post(`/api/admin_market_price/`, this.DialogFormData)
          .then((data) => {
            this.$emit("submitDialog");
            this.Hide();
          });
      });
    },
    downloadTemplate() {
      window.open(
        "https://oss.chinaduancai.com/import_market_price_template.xlsx"
      );
    },
  },
};
</script>


<style scoped lang="scss">
</style>

